
import CommonHeading from "../../common-component/common-heading/CommonHeading";
import "./RoleSection.css";
import { Container, Row, Col } from "react-bootstrap";

const roles = [
  {
    title: "Brand Marketing Manager",
    description: "Shape brand strategy and customer perception.",
    salary: "8-20 LPA",
  },
  {
    title: "Growth Manager",
    description: "Identify opportunities and accelerate business growth.",
    salary: "8-19 LPA",
  },
  {
    title: "Growth Marketing Manager",
    description: "Scale growth through data-driven marketing strategies.",
    salary: "8-20 LPA",
  },
  {
    title: "Product Manager",
    description: "Lead product strategy, development, and growth.",
    salary: "9-30 LPA",
  },
  {
    title: "Senior Business Analyst",
    description: "Transform data into actionable business insights.",
    salary: "9-18 LPA",
  },
  {
    title: "Portfolio Manager",
    description: "Manage investments and optimize portfolio performance.",
    salary: "8-14 LPA",
  },
];

export default function RolesSection() {
  return (
    <section className="roles_section">
      <Container>
        <div className="section_heading">
          
            <CommonHeading
          subTitle=" Roles That Reward"
          title=" Your Ambition"
           description="   Discover career opportunities across high-growth industries."
        />
        </div>

        <Row className="g-4">
          {roles.map((item, index) => (
            <Col lg={6} key={index}>
              <div className="role_card">
                <div className="role_content">
                  <h4>{item.title}</h4>
                  <p>{item.description}</p>
                </div>

                <div className="salary_box">
                  <h3>{item.salary}</h3>
                  <span>Avg salary</span>
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
}